import React, { useState } from "react";
import { Box } from "@mui/material";
import SearchBar from "../../Components/search/Search";
import Table, {
  type TableColumn,
} from "../../Components/CommonTable/CommonTable";
import InfoCard from "../../Components/InfoCard/InfoCard";
import { useNavigate } from "react-router-dom";

interface StudyMaterial {
  subject: string;
  classGroup: string;
  totalMaterial: number;
  fileType: string;
  lastUploadDate: string;
  [key: string]: unknown;
}

const StudyMaterialsTopic = () => {
  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState("");
  const handleRowClick = (row: StudyMaterial) => {
    // later you can pass row.subject or row.classGroup as params if needed
    navigate("/study_materials/sub-topic");
  };

  const handleSearchSubmit = () => {
    console.log("Search submitted:", searchValue);
  };

  const columns: TableColumn<StudyMaterial>[] = [
    { key: "subject", title: "Subject", sortable: true },
    { key: "classGroup", title: "Class/Group", sortable: true },
    {
      key: "totalMaterial",
      title: "Total Material",
      sortable: true,
      align: "center",
    },
    { key: "fileType", title: "File Type", align: "center" },
    { key: "lastUploadDate", title: "Last Upload Date", sortable: true },
  ];

  const data: StudyMaterial[] = [
    {
      subject: "English",
      classGroup: "Class 5th",
      totalMaterial: 8,
      fileType: "PDF",
      lastUploadDate: "Today",
    },
    {
      subject: "Mathematics",
      classGroup: "Class 5th",
      totalMaterial: 12,
      fileType: "PDF",
      lastUploadDate: "20-07-2025",
    },
    {
      subject: "General Knowledge",
      classGroup: "Class 5th",
      totalMaterial: 8,
      fileType: "PDF",
      lastUploadDate: "23-07-2025",
    },
    {
      subject: "Hindi",
      classGroup: "Class 6th",
      totalMaterial: 10,
      fileType: "PDF",
      lastUploadDate: "25-07-2025",
    },
    {
      subject: "Tamil",
      classGroup: "Class 6th",
      totalMaterial: 8,
      fileType: "PDF",
      lastUploadDate: "26-07-2025",
    },
    {
      subject: "Computer",
      classGroup: "Class 6th",
      totalMaterial: 5,
      fileType: "PDF",
      lastUploadDate: "27-07-2025",
    },
    {
      subject: "Moral Science",
      classGroup: "Class 7th",
      totalMaterial: 8,
      fileType: "PDF",
      lastUploadDate: "28-07-2025",
    },
    {
      subject: "Science",
      classGroup: "Class 7th",
      totalMaterial: 11,
      fileType: "PDF",
      lastUploadDate: "Month Ago",
    },
    {
      subject: "Social Science",
      classGroup: "Class 7th",
      totalMaterial: 12,
      fileType: "PDF",
      lastUploadDate: "Month Ago",
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "25px" }}>
      {/* <Box>
        <SearchBar
          value={searchValue}
          onChange={setSearchValue}
          placeholder="Search here..."
          onSubmit={handleSearchSubmit}
        />
      </Box> */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          gap: "30px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <InfoCard
            title="Welcome to Everest Tutoring"
            subtitle="recent activity"
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <InfoCard
            title="Welcome to Everest Tutoring"
            subtitle="recent activity"
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <InfoCard
            title="Welcome to Everest Tutoring"
            subtitle="recent activity"
          />
        </Box>
      </Box>
      <Box>
        <Table<StudyMaterial>
          columns={columns}
          data={data}
          onRowClick={handleRowClick}
        />
      </Box>
    </Box>
  );
};

export default StudyMaterialsTopic;
